import { render } from "./Footer.vue?vue&type=template&id=acd11d14"
const script = {}

import exportComponent from "D:\\01.CargIns\\carginssbcsys\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__